import React from 'react';

/**
 * Pinned observations ("Doug prefers a call to email") — institutional memory that
 * sits with the client's standing facts (spec §3.2), not a message. Renders nothing
 * when there are none, never an empty block. Only pinned notes are passed in.
 *
 * @param {object} props
 * @param {Array<{id?:string,title?:string,body?:string}>} [props.notes]
 */
export default function PinnedNotes({ notes = [] }) {
  if (!notes.length) return null;
  return (
    <section aria-label="Pinned notes">
      <h2 className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Pinned notes</h2>
      <ul className="space-y-2">
        {notes.map((n, i) => (
          <li
            key={n.id || i}
            className="rounded-lg border border-amber-100 bg-amber-50 px-3 py-2 text-sm dark:border-amber-900/30 dark:bg-amber-900/15"
          >
            {n.title && <div className="font-medium text-gray-900 first-letter:uppercase dark:text-gray-100">{n.title}</div>}
            {n.body && <div className="text-gray-600 first-letter:uppercase dark:text-gray-300">{n.body}</div>}
          </li>
        ))}
      </ul>
    </section>
  );
}
